// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import Close from "@stoneage/XDL/Icons/IconClear";
import AlertInfo from "@stoneage/XDL/Icons/IconInformation";
import AlertError from "@stoneage/XDL/Icons/IconNotificationError";
import AlertSuccess from "@stoneage/XDL/Icons/IconSuccess";
import AlertWarning from "@stoneage/XDL/Icons/IconWarning";
import { fontConfig } from "@stoneage/XDL/constants";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color, hideElementOnPrint } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            variant: "link" as any,
            color: "common.ui6",
            css: css`
                position: absolute;
                top: 10px;
                right: 12px;
                border: 0;
                width: 12px;
                height: 12px;
                padding: 0;
                min-height: unset;
                &,
                &:hover,
                &:focus {
                    background: none;
                }
                svg {
                    color: ${color("common.ui8")};
                }
                &:hover ${IconWrapper} {
                    color: ${color("primary")};
                }
            `,
        },
        closeButtonIconProps: {
            src: Close,
            size: 12,
            color: "common.ui8",
        },
        iconProps: {
            mergeCss: true,
            size: 16,
            css: css`
                margin-right: 8px;
            `,
        },
        iconSrcByMessage: {
            success: AlertSuccess,
            warning: AlertWarning,
            danger: AlertError,
            info: AlertInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                &,
                ${TypographyStyle} {
                    font-size: ${fontConfig.smallSingleLine.size}px;
                    line-height: ${fontConfig.smallSingleLine.lineHeight};
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                ${hideElementOnPrint}
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: flex-start;
                padding: 8px 32px 8px 12px;
                width: 100%;
                margin-top: 2px;
                white-space: pre-wrap;
                word-break: break-word;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
